import { useAppState } from 'src/state';
import { formatDate, formatTime } from 'src/utils/dates';
import { BreadcrumbComponentProps } from 'use-react-router-breadcrumbs'

export function OperationsAdminVenueBookingBreadCrumb({}:BreadcrumbComponentProps): React.ReactElement {
    const { currentItem } = useAppState().bookings
    if (!currentItem) return <span>Booking</span>;
    return (
        <span>{`${currentItem?.talent_id ? currentItem.talent?.name : 'Unassigned'} ${formatDate(currentItem?.date)} ${!!currentItem?.set_start_time ? '@ ': ''}${formatTime(currentItem?.set_start_time)}`}</span>
    );
}